import React from 'react';

const Section$ = () => <div style={{textIndent: '2em'}}>
    <div style={{textAlign: 'center'}}>
        <br/>
        <h1 name="0-13" className="point" id="0-13">第十四章 设备管理制度</h1></div>
    <div style={{textIndent: '2em'}}>
        <br/>

        <h1 name="0-13" className="point" id="0-13">第十四章 设备管理制度</h1>
        <h2 name="0-13-0" className="point" id="0-13-0">一、重点设备使用规范</h2>
        <h3 name="0-13-0-0" className="point" id="0-13-0-0">1、生活重点设备使用规范</h3>
        <h4 name="0-13-0-0-0" className="point" id="0-13-0-0-0">1.1消防泵操作规范</h4>
        <p>1、消防水泵房值班人员使用消防水泵应按规定要求及时通知运行消防中心值班人员。</p>
        <p>2、消防水泵房的消防水泵确定为自动启动和手动停止的运行方式。</p>
        <p>3、消防泵房的消防水泵的自动（压力开关控制）启运过程。在消防泵房的配电消防水泵控制柜，把电源开关操作手柄打在“ON”的位置，当消防水管风铁压力低于7.5kg/cm2时，消防泵房的另一台消防水泵启动供水，这时两台消防泵同时工作。</p>
        <p>4、消防水泵的“停止”操作步骤：在消防控制配电柜控制的“自动/手动”选择开关上选择手动后，按下消防泵房的消防水泵的“停止”按钮，停止消防泵房的消防水泵工人，或在现场电动消防泵控制盘上按下“停止”按钮，停止消防泵房的消防水泵工作。</p>
        <p>5、水泵房消防水泵手动控制操作步骤：在消防控制盘的“自动/手动”选择开关上选择“手动”。在消防泵房的消防水泵控制箱上，把电源开关操作手柄打在“ON”的位置。在消防主控盘按下消防电动消防泵“启动”按钮，启动消防泵房的消防水泵。在消防主控盘按下消防水泵“停止”按钮，停止消防泵的消防水泵。</p>
        <p>6、消防泵房的消防水泵控制箱就地操作步骤：在消防泵的消防水泵控制箱，把电源开关操作手柄打在“ON”的位置。在消防泵房的消防水泵控制箱上按下“启动”按钮，启动消防泵房的消防水泵。在消防泵房的消防水泵控制箱上按下“停止”按钮，停止消防泵房的消防水泵。</p>
        <h4 name="0-13-0-0-1" className="point" id="0-13-0-0-1">1.2太阳能热水控制箱操作规范</h4>
        <p>1、设置键：用来设置电加热的温度上限和加水的水位上限；</p>
        <p>2、加水水位键：加水或终止加水；进入设置后用来设置水位上限的值；设置定时加水或取消定时加水；</p>
        <p>3、加温水温键：加热或终止加热；进入设置后用来设置温度上限的值；设定定时加热或取消定时加热；</p>
        <p>4、管道保温键：启动关闭管道保温；或“管道循环键”：启动关闭管道循环；</p>
        <p>5、温控开关键：手动关闭或开启温控上水功能。</p>
        <h4 name="0-13-0-0-2" className="point" id="0-13-0-0-2">1.3自来水增压泵房运行管理规范</h4>
        <p>1、增压泵房卫生保持整洁，无有毒有害物质存放。</p>
        <p>2、每日查看设备运行情况，并作记录。</p>
        <p>2.1、增压泵是否正常运行，是否有杂音。</p>
        <p>2.2、压力表的设定压力是否在正常范围。</p>
        <p>3、定期取样查看水质浑浊度，如有异常及时查明原因。</p>
        <p>4、每月打开压力罐排污阀排除污水，并作相关记录。</p>

        <h3 name="0-13-0-1" className="point" id="0-13-0-1">2、生产重点设备使用规范</h3>
        <h4 name="0-13-0-1-0" className="point" id="0-13-0-1-0">2.1轮胎拆装机安全使用规范</h4>
        <p>1、由专人负责设备的定期技术保养。</p>
        <p>2、操作使用时，非操作人员勿靠近机器。</p>
        <p>3、严禁机器直接接触水，避免异物进入运动件。</p>
        <p>4、扒胎受阻，应立即停止，让转盘逆时针转动，清除障碍。</p>
        <p>5、扒胎时尽量使身体远离运动件。</p>
        <p>6、在撑夹轮毂过程中，严禁把手放在轮胎和夹钳之间。</p>
        <p>7、轮胎应按照轮胎厂家的胎压标准进行充气。</p>
        <p>8、设备出现故障时，请勿使用。</p>
        <h4 name="0-13-0-1-1" className="point" id="0-13-0-1-1">2.2动平衡机安全使用规范</h4>
        <p>1、保证动平衡机底座与地面接触完好，不晃动。</p>
        <p>2、轮胎装卸时应防止碰撞动平衡机机体。</p>
        <p>3、清除轮胎上的泥土和铅块，检查转盘固定螺母是否锁紧。</p>
        <p>4、平衡机运行时，严禁用手或其他物品接触旋转部位。</p>
        <p>5、工作时，发现异常，应立即停机检查。</p>
        <p>6、保证镶嵌平衡块牢靠不晃动。</p>
        <p>7、工作结束，应清理动平衡机上的泥土和赃物。</p>
        <h4 name="0-13-0-1-2" className="point" id="0-13-0-1-2">2.3角磨机安全使用规范</h4>
        <p>1、佩戴保护眼罩。</p>
        <p>2、检查线束是否损坏漏电，磨片是否完好。</p>
        <p>3、打开开关后，要等砂轮转动稳定后才能工作。</p>
        <p>4、长发操作者请勿使用。</p>
        <p>5、切割方向不能朝向人。</p>
        <p>6、连续工作半小时要停机十五分钟。</p>
        <p>7、不能用手固定零件用角磨机进行加工。</p>
        <h4 name="0-13-0-1-3" className="point" id="0-13-0-1-3">2.4手电钻安全使用规范</h4>
        <p>1、用前检查电源线有无破损。</p>
        <p>2、打孔时要双手紧握电钻，尽量不要单手操作，应掌握正确操作姿势。</p>
        <p>3、不能使用有缺口的钻头，钻孔时向下压的力不要太大，防止钻头打断。</p>
        <p>4、清理刀头废屑，换刀头等这些动作，都必须在断开电源的情况下进行。</p>
        <p>5、对于小工件必须借助夹具来夹紧，再使用手电钻。</p>
        <p>6、操作时进钻的力度不能太大，以防钻头或丝攻飞出来伤人。</p>
        <p>7、要先关上电源，等钻头完全停止再把工件从工具上拿走。</p>
        <h4 name="0-13-0-1-4" className="point" id="0-13-0-1-4">2.5电动单梁起重机安全操作规程</h4>
        <p>1、操作人员应了解起重机的性能，机械结构及其他相关知识。</p>
        <p>2、操作人员在操作时应注意力集中，不准吸烟、吃东西或其它与操作无关的事。</p>
        <p>3、开机前检查：</p>
        <p>各部件是否有异常现象；</p>
        <p>吊钩、操作手柄、按钮、遥控器是否灵活可靠；</p>
        <p>钢丝绳是否有断股、磨损、严重折痕；</p>
        <p>限位器及其它安全装置是否安全可靠。</p>
        <p>4、无载荷情况下接通电源开动并检查各运转机构、控制系统和安全装置，电动葫芦的制动器应灵敏、准确、可靠。</p>
        <p>5、操作注意事项：</p>
        <p>①起吊重物不得超过起重机规定重量；</p>
        <p>②起吊时，操作人员与吊运物应保持有效的安全距离。吊钩下方不得站人，重物不得越人行走。操作人员跟车行走时，应注意周围情况，防止绊倒或其它事故发生。</p>
        <p>③限位器为保护装置，不得当开关使用。严禁无导绳器或限位器操作。</p>
        <p>④严禁使用反车当刹车使用。</p>
        <p>⑤两台以上大车同时运行时，应保持一定距离，严格禁止互撞。</p>
        <p>6、严格执行十不吊制度：</p>
        <p>①指挥不明或乱指挥不吊；</p>
        <p>②超过额定起重量不吊；</p>
        <p>③吊具使用不合理或其它浮放物不吊；</p>
        <p>④吊物上有人或物件捆绑不牢不吊；</p>
        <p>⑤抱闸或其它制动安全装置失灵不吊；</p>
        <p>⑥行车吊挂重物，直接加工时不吊；</p>
        <p>⑦歪挂斜挂不吊；</p>
        <p>⑧具有爆炸性物件不吊；（如氧气瓶、乙炔瓶等）</p>
        <p>⑨埋在地下物件不拔不吊；</p>
        <p>⑩带棱角块的物件，未垫好不吊停止使用应将吊钩开离地面2米以上，大车停靠在指定位置，控制电源置于零位。</p>
        <p>7、起重机停止工作后，将电葫芦停放在主梁远离大车滑触线一端，不得置于跨中部。</p>
        <p>8、电动葫芦工作时，不允许悬挂重物，以防设备或部件产生变形。</p>
        <p>考核：操作者必须按要求操作，违反者考核100分/次，情节严重者另议。</p>
        <h4 name="0-13-0-1-5" className="point" id="0-13-0-1-5">2.6电焊、氧气乙炔安全操作规范</h4>
        <p> (一)、一般规定 </p>
        <p>1、电、气焊操作人员必须经过严格的培训，了解并掌握电、气焊操作技术，熟悉电、气焊设备，经培训合格持证后方可操作，人员培训按公司相关规定执行； </p>
        <p>2、在对运动设备维修前，必须锁上相应设备开关，并在主控开关上挂锁；</p>
        <p> 3、必须对运转时会对作业造成危险的相关设备实行断电停机并挂牌上锁；</p>
        <p>4、必须确认设备已完全停止，对制动系统可靠性不能完全确认或维修时可能改变系统受力稳定性的维修作业，应另实施安全保障措施后才能作业； </p>
        <p>5、特殊场所，如煤磨系统、库房、袋收尘器等，必须有动火证才能进行电气焊作业；</p>
        <p>6、操作前要认真检查电、气焊工器具，发现问题要及时报告并处理； </p>
        <p>7、工作中应正确使用、保管高压氧气瓶和乙炔瓶，正确调整电焊机电流，保证安全生产；</p>
        <p> 8、在使用电焊机前应仔细检查，确认设备安全情况，焊机接入电网时必须注意两者电压是否相符；</p>
        <p> 9、起动焊机时焊钳和焊件不能接触以防短路； </p>
        <p>10、接线柱和电缆应接触良好，不许松动。焊机外壳接地应良好以确保安全；</p>
        <p>11、氧气瓶和乙炔瓶两个压力表不应互相对峙以免气流射出时冲击另一块表造成事故；</p>
        <p>12、冬天氧气出口处如有冻结现象，严禁使用明火加热，以免氧气突然大量冲出造成事故；</p>
        <p>13、氧气瓶、乙炔瓶不能用起重机直接挂吊，如在高空施工必须吊运时，应装入吊蓝或适当台架上进行；</p>
        <p>14、对电焊、气割、气焊作业时都应采取必要的防火措施；</p>
        <p>15、操作人员在2米以上施工时，要佩戴安全带和采取防护措施；</p>
        <p>16、对有一次仪表（如负荷传感器等）的设备焊割时，应与仪表技术人员联系。</p>
        <p>1考核：操作者必须按要求操作，违反者考核100分/次，情节严重者另议。</p>

        <p>二、气焊、气割的安全规定 </p>
        <p>1、进行气焊和气割时，必须戴上墨镜；</p>
        <p>2、严禁氧气乙炔瓶、带接触油料。氧气、乙炔瓶距不得小于5米；必须留有余气；</p>
        <p>3、焊接场所15米以内不得存放易燃易爆物品；</p>
        <p>4、禁止在输电线路下放置乙炔瓶、氧气瓶等气焊设备； </p>
        <p>5、操作者在焊接过程中，使用乙炔气瓶时严禁卧放使用；且不得剧烈振动及受阳光爆晒，开启时要使用专用扳手；</p>
        <p>6、电焊和气焊在同一场所时，氧气瓶必须采取绝缘措施，乙炔气瓶要有接地措施；</p>
        <p>7、焊接所使用的氧气瓶要远离明火或热源10米以上，乙炔瓶应与明火距离保持在3米以上；</p>
        <p>8、严禁将正在燃烧的焊割炬随意放置； </p>
        <p>9、气焊设备严禁沾染油污和搭架各种电缆; </p>
        <p>10、使用气瓶的操作人员，严禁穿着容易产生静电的化纤服装; </p>
        <p>考核：操作者必须按要求操作，违反者考核100分/次，情节严重者另议。</p>
        <h4 name="0-13-0-1-6" className="point" id="0-13-0-1-6">2.7 电焊机安全操作规程</h4>
        <p>1、焊接前电焊机应放在通风、干燥、平稳的地方。</p>
        <p>2、焊接罩应无漏光、破损，工作人员应穿戴好规定的劳动保护用品，并设置挡光屏隔离焊件发出的辐射热。</p>
        <p>1、电焊机、焊钳、电源线以及各接头部位要联结可靠，绝缘良好，不允许接线处发生过热现象，电源接线端头不得外露，应用绝缘布包扎好。</p>
        <p>4、电焊机与焊钳的导线长度不得超过30m，导线有受潮、断股现象立即更换。</p>
        <p>5、电焊线通过道路时，必须架高或穿入防护管内埋设在地下，通过轨道时，需从轨道下面穿过。</p>
        <p>6、根据工件技术条件，选用合理焊接工艺（焊条、焊接电流和暂载率），不允许超负载使用，不准采用大电流施焊和用电焊机进行金属切割作业。</p>
        <p>7、移动电焊机时，应切断电源，不得用拖拉电缆的方法移动电焊机，如焊接中突然停电，应切断电源。</p>
        <p>8、禁止在起重运行工件下面作焊接作业。</p>
        <p>9、必须在潮湿处施焊时，焊工应站在绝缘木板上，不准用手触摸电焊机导线，不准用臂夹持带电焊钳，以免触电。</p>
        <p>10、完成焊接作业后，应立即切断电源，关闭电焊机开关，分别清理归整好焊钳电源和地线，以免合闸时造成短路。</p>
        <p>11、清除焊缝焊渣时，要戴上眼镜，注意头部应避开敲击焊渣飞溅方向，以免刺伤眼睛，不能对着在场人员敲打焊渣。</p>
        <p>考核：操作者必须按要求操作，违反者考核100分/次，情节严重者另议。</p>
        <h4 name="0-13-0-1-7" className="point" id="0-13-0-1-7">2.8千斤顶安全操作规程</h4>
        <p>1.使用前必须检查其完好状况，发现危害安全的问题立即处理，有问题的千斤顶不允许使用，保障安全可靠。油压式的活塞阀门必须良好，油量必须充足，并保持清洁。</p>
        <p>2．用千斤顶支起车辆作业时，必须选择平坦、坚实场地并用角木将着地的前后轮塞稳，以防滚动滑脱；然后用安全凳、支撑架或木方按车型规定支撑点将车辆支撑稳固，不准在各支承点垫放砖块等易碎，易滑物件，严禁车辆同时一边架空，防止车轮滑动，杜绝垮垮塌事故。</p>
        <p>3.用千斤顶将车放下时，要先检查周围有无障碍物和压人危险，确认安全后，撤掉支撑物，缓慢打开液压开关，车轮落地后，撤掉千斤顶。</p>
        <p>4．必须按规定的承重能力选用千斤顶，不得超载和超过规定的升起高度。如规定铭牌不详时，其上升高度不得超过螺杆或活塞总高度的四分之三。</p>
        <p>5.一台千斤顶顶重物时，必须掌握好顶物的重心。顶起时，顶身与顶物要垂直对正，防止重心偏移滑脱。</p>
        <p>6.使用多台千斤顶顶升重物时，应尽量选用同一规格和型号。每个千斤顶受力必须均匀，放在重心两侧力矩对称的位置上。应按总负荷留有百分之二十至百分之五十的富余起重力。顶升的形成速度必须保持相等、平衡。</p>
        <p>7.重物顶起后，须随起随垫，其脱空距离不准超过5厘米，以防滑脱、倾倒发生事故。</p>
        <p>8.千斤顶受力后，需检查机件、地基、垫木、重心是否正常，发现问题立即处理，确认安全无误后，方可继续操作。</p>
        <p>9.使用千斤顶必须明确分工，有专人指挥和监视。</p>
        <p>10.千斤顶作业时，非操作人员不准靠近，配合操作的人员应随时注意顶物的倾斜变化。千斤顶升起或下降时，严禁在顶物下作业或伸入手脚。顶物升起后，需在下作业时，重物必须按规定垫实。</p>
        <p>考核：操作者必须按要求操作，违反者考核100分/次，情节严重者另议。</p>
        <h4 name="0-13-0-1-8" className="point" id="0-13-0-1-8">2.9压床安全技术操作规范</h4>
        <p>1、禁止不了解本机器的结构、性能和操作规程者，不得擅自开动机器。</p>
        <p>2、工作前应根据工件的高度调整好限位装置，并开机使活塞带动模樑上下运行各动作正常，才能带负荷工作。工作过程中因液压系统的故障等原因，须停机并请维修工排除，并要做好预防活动模樑因意外失控时的安全防护措施，避免发生事故。</p>
        <p>3、当发现设备有严重漏油或其他异常时，如动作不可靠、噪音大、振动或冲击等应停机分析原因，设法消除故障，不得使机器带病工作。</p>
        <p>4、严格按照压床设定限制操作，不得超载与偏载工作。</p>
        <p>5、严禁各油缸超过最大行程使用。</p>
        <p>6、电器设备接地装置牢固可靠。</p>
        <p>7、模具、垫铁不得有裂纹，放置要平稳可靠，使用吊车要密切配合，吊装必须牢固可靠，机器在工作过程中不准检修和调换模具。</p>

        <p>考核：操作者必须按要求操作，违反者考核100分/次，情节严重者另议。</p>
        <h2 name="0-13-1" className="point" id="0-13-1">二、精密设备仪器使用规范</h2>
        <h3 name="0-13-1-0" className="point" id="0-13-1-0">1、摄影摄像器材使用规范</h3>
        <p>为加强集团公司摄影摄像器材的管理，充分发挥器材设备的使用效益，现结合实际，制定本细则。</p>
        <p>适用范围：本制度用于摄影摄像器材使用者及管理者。</p>
        <p>第一条 本制度所指摄影摄像器材包括照相机、摄影机、电池、内存卡、云台、三脚架等专用器材设备。</p>
        <p>第二条 摄影摄像器材的使用、保管、借出和维护，都必须适用本制度。</p>
        <p>第三条 摄影摄像器材的使用和管理工作由企宣部摄制组负责。</p>
        <p>第四条 器材的使用保管</p>
        <p>（一）摄影摄像器材的管理实行“谁主管、谁负责，谁使用、谁负责”的原则。企宣部是摄影摄像器材管理工作的责任部门，要根据实际使用情况，将器材指定给具体管理人员管理和使用。</p>
        <p>（二）管理人员要切实做好器材设备的日常管理工作，使用时应严格按照使用说明和技术操作规程认真操作。如因操作不当造成故障，损坏的器材尚能修复，不降低性能和精度的，使用人应全额赔偿维修费和损坏的零件费；不能修复的，应根据实际情况折价赔偿。非管理人员人为原因，需进行正常维修器材设备的，应填写相关申请表，报领导审批。</p>
        <p>（三）摄影摄像器材配备给企宣部部工作人员后，只能用于集团公司安排的工作，不得擅自使用，不得擅自转借他人。如因擅自使用或转借他人造成器材损坏或丢失的，按以下规定处理：</p>
        <p>1.赔偿损坏器材的维修费；</p>
        <p>2.如损坏器材无法维修或丢失的，需根据器材购置原值经折旧后进行赔偿；</p>
        <p>3.人为有意损害器材的，除按折旧赔偿外，还应视情节轻重给予处分，严重者依法追究责任；</p>
        <p>4.折旧器材被盗或丢失后，在查出案件或事故当事人之前，暂由器材保管者负责赔偿损失。</p>
        <p>（四）不得使用集团公司摄影、摄像器材私自承接音像制品制作、摄影、摄像、录音和设计等业务。如需为外单位摄影、摄像或制作音像制品的，应报领导同意。</p>
        <p>第五条 器材的借用 </p>
        <p>（一）本集团公司员工如需使用照相机、摄影机、电池、内存卡、云台、三脚架等，要严格履行借用登记手续，填写器材设备借用申请，并经领导签字同意。如因工作需要延长使用时间，应重新填写申请表,并经领导签字同意。</p>
        <p>（二）除本公司员工外，网站借来的器材一律禁止外借。</p>
        <p>（三）交还器材时，管理人员应认真检查器材是否能够正常使用、设备配件是否齐全等。</p>
        <p>如不能正常使用或设备不齐全的，应立即进行处理。</p>
        <p>第六条 器材的维护</p>

        <p>摄影摄像器材的使用和管理工作由信息化部负责。</p>
        <p>（一）管理人员要经常对器材设备的存放环境进行检查，不能将器材放置在高湿、高温、强磁场、强电场和强震动的环境中，避免尘、水的坏境，应保证器材的完好无损。</p>
        <p>（二）要经常对器材设备进行保养和维护，定期进行充电、试验、检查、擦拭等。每月要</p>
        <p>对所有摄影摄像器材进行一次检测，如发现设备故障，应及时维修维护。</p>
        <p>第六条 本规定自印发之日起正式施行。</p>
        <h3 name="0-13-1-1" className="point" id="0-13-1-1">2、数字绝缘电阻测试仪使用规范</h3>
        <p>数字绝缘电阻测试仪使用规范及注意事项：</p>
        <p>1、确认被测物安全接地，且被测物不带电。</p>
        <p>2、确认仪表E端（接地端）已接地。</p>
        <p>3、测试完毕，请及时关闭高压和工作电源。应经常保持外表清洁，必要时可用干净布擦拭。仪表长期不用时，必须将电池取出以免腐蚀仪器，且仪表不得受潮、雨淋、曝晒或跌落等。</p>
        <p>4、读数完毕，首先按下按钮关断高压，高压指示熄灭。再将功能选择开关置于“ON”挡，关闭电源。对容性负载，还应将被测试件上的残余电荷泄放完，再拆卸测试线，以免电击伤人。</p>
        <p>5、测量高绝缘电阻值时，应在被测物两端之间的表面上套一导体保护环，并将该导体保护环用一测试连接到仪表的保护端子，以消除被测物表面泄漏电流引起的测量误差，保障测试准确。</p>
        <h3 name="0-13-1-2" className="point" id="0-13-1-2">3、轮轴定位设备操作规范</h3>
        <h4>1、车辆停放及相关检查要求</h4>
        <p>停放要求：车辆停放需要在相对平整和水平的地面上进行操作。</p>
        <p>胎压检查：使用胎压表，测量车轮的轮胎胎压是否在标准范围内；标准胎压请参考轮胎上打印的压力要求。</p>
        <p>转向拉杆检查：使用大力钳和千分表，检查转向拉杆部件上的球接头间隙是否都在标准范围内，如果测量的值超出标准范围，请先更换间隙过大的球接头。</p>
        <h4>2、设备安装到车辆上</h4>
        <h4>2.1 安装自对中心标尺（及吊具）</h4>
        <p>2.1.1 标尺是分三段进行组装的，在段与段连接之间是依靠大螺母进行锁固的，确保每段的标杆全部安装在卡槽内；</p>
        <p>2.2.2 安装标尺的吊具，确保两侧的吊具都在同一刻度上；将标尺悬挂在车间上并紧固螺母，锁定标尺宽度；</p>
        <p>2.2.3 检查标尺的水平仪在刻线的中间位置。</p>
        <p>2.2.4 在车辆的前后端，各悬挂一根标尺。</p>
        <p>标尺安装见下图：</p>

        <h4>2.2 安装反射标靶</h4>
        <p>在标尺的每一段，安装反射标靶；参照标靶上的“X”的图示位置，安装标靶至正确的车轮位置；确保标靶在标杆上安装的孔位置都在同一个位置。见下图：</p>


        <h4>2.3 安装车轮卡具：</h4>
        <p>首先将卡具的下方卡点放在轮辋上，通过逆时针旋调节螺栓，将卡具上方的两个支点也卡在轮辋内；确保四个支点全部牢固的卡在轮辋上。见下图：</p>

        <p>备注：根据车辆故障特征，选择安装车轮卡具到转向轴还是驱动轴。</p>
        <h4>2.4 安装摄像头</h4>
        <p>将摄像头安装在车轮卡具上，确保摄像头安装孔内的卡簧卡在卡具上的卡槽内，以免造成摄像头自行脱落掉地损坏的风险。</p>


        <h4>3、开启测量软件与摄像头进行通信</h4>
        <p>3.1 点按摄像头后部的“ON\OFF”键，打开摄像头的电源。</p>
        <p>3.2 开启轮轴定位设备专用笔记本，在屏幕桌面上找到“CamAligner”软件快捷方式，双击打开。</p>
        <p>3.3 在弹出的管理主页界面中，找到“设置”选项，并点击一下。</p>
        <p>3.4 在弹出的界面中，找到“通讯”选项，并点击一下，在界面顶部找到“配对”选项并点击；按照图示说明进行操作，直到操作软件界面的摄像头数字标识显示成绿色的，此时，操作软件和摄像头完成建立通信。</p>
        <p>3.5 点击左上角的“后退”选项，再点击“主页”选项，使操作界面回到主页位置。</p>
        <h4>4、建立新的工作单</h4>
        <p>4.1 在操作软件的主界面上，点击“新工作单”选项，按照软件提示内容先对车辆进行检查；完成检查后，再点击右上角的“下一步”。</p>
        <p>4.2 在弹出的界面中，输入车辆及相关信息，见下图：</p>


        <p>4.3 界面直接跳转到车型设置界面，按照图示说明要求，选择和被检测车辆一样的车型及相关设置。见下图：</p>

        <p>4.4 完成车辆选项后，再点击右上角的“下一步”选项，使操作软件进入到测量界面。</p>

        <p>4.4.1 先进行同轴度调整，按照软件指示步骤，完成操作。</p>
        <p>4.4.2 选着要测量的车轴。</p>
        <p>4.4.3 选着车辆“所有角度”选项，按照软件指示步骤，完成操作。</p>
        <h2 name="0-13-2" className="point" id="0-13-2">三、对应设备各项表格范本</h2>

    </div>
</div>;

export default Section$;